import { overlay } from '../../../user/animations.overlay';
import { ShareMenu, rotateOpen, rotateDown } from '../../animations';

import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { flyInOut, fadeIn, fade, zFade, Cart, ProductInfo, Stock, CartStep, CartOverlay, CartBackdrop, steppedFly, storeFilters, storetitle,viewInfo,viewDesc } from '../../animations';
import { DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { SelectComponent } from 'ng-select';
import { Observable } from 'rxjs/Rx';

import { Statistic } from '../../../models/statistics';
import { StoreService } from '../../../services/store.service';
import { UserService } from '../../../services/user.service';

declare var $: any;

@Component({
  selector: 'share-menu',
  templateUrl: './share.menu.html',
  inputs: [ 'clickToActivate', 'singleArrow', 'urlParams' ],
  animations: [overlay,flyInOut, fadeIn, fade, rotateDown, zFade, Cart, ProductInfo, Stock, CartStep, CartOverlay, CartBackdrop, steppedFly, storeFilters, storetitle,viewInfo,viewDesc,ShareMenu,rotateOpen]
})
export class ShareMenuComponent implements OnInit {

	@Input() clickToActivate:any = false;
	@Input() singleArrow:any = false;
	@Input() sharelisting:any;
	@Input() urlParams:any;

	socialStatistics: Statistic;
	shareMenuOpen = false;
	shareOverlay = false;

	isCopied: boolean;
	localURI: string;
	shareWindow: string;
	windowLink: string;

	constructor(private storeService: StoreService,
				private userService: UserService,
				private route: ActivatedRoute,
				private sanitizer: DomSanitizer,
				private router: Router) { }

	getURL() {
		if ( this.urlParams ) {
			this.windowLink = window.location.href + '/' + this.urlParams;
		} else {
			this.windowLink = window.location.href;
		}
	}

	focusLink() {
		this.shareOverlay = true;
	}

	doShare(service, listing?) {

		let prefix = '';
		if ( listing ) {
			this.sharelisting = listing;
			if ( this.sharelisting.title != '' ) { prefix = ' - ' + this.sharelisting.title; }
			if ( this.sharelisting.description != '' ) { prefix = prefix + ' - ' + this.sharelisting.description; }
		}

		// Meta details for sharing
		let title = 'Identity RPG'+prefix;
		let url = this.windowLink;

		switch (service) {
			case "facebook":
				var fbbase = 'https://www.facebook.com/sharer.php?u=';
				var fbs = fbbase + url + '&t=' + title;
				this.openWindow('265', '640', 'Share Identity on Facebook', fbs);
			break;
			case "twitter":
				var twbase = 'https://twitter.com/share?url=';
				var tws = twbase + url + '&text=' + title;
				this.openWindow('289', '624', 'Tweet about Identity', tws);
			break;
			case "google":
				var tmbase = 'https://plus.google.com/share?url='+url+'&name="Identity RPG - '+this.sharelisting.title+'"';
				this.openWindow('590', '400', 'Share Identity on Google Plus', tmbase);
			break;
			case "tumblr":
				var tmbase = 'https://plus.google.com/share?url='+url+'&name=Identity RPG - '+this.sharelisting.title+'&description='+this.sharelisting.description;
				this.openWindow('289', '624', 'Share Identity on Tumblr', tmbase);
			break;
			case "email":
				window.location.href = "mailto:address@gmail.com";
			break;
			default:

			break;
		}

	}


	openWindow(windowHeight, windowWidth, windowName, windowUri) {

		var centerWidth = (window.screen.width / 2) - windowWidth;
		var centerHeight = (window.screen.height / 2) - windowHeight;

		let newWindow = window.open(windowUri, windowName, 'resizable=0,width=' + windowWidth + 
			',height=' + windowHeight + 
			',left=' + centerWidth + 
			',top=' + centerHeight);

		newWindow.focus();
		return newWindow.name;
	}


	ngOnInit() {

		this.getURL();

		/* 
		* Statistics
		*/
		Promise.resolve( this.storeService.getSocialStatistics() ).then( (stats) => {
			this.socialStatistics = stats;
		});
		

	}

}



// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/store/_partials/share-menu/share.menu.component.ts